module.exports = __webpack_public_path__ + "media/images/riders/small/MANUEL_FUMIC-d62c0b482ec01b2e1193ed83080ac1ed.png";